import PropTypes from 'prop-types';
import styles from './Product.module.css';
import { ProductThumbnail } from '../../../Helpers/ThumbHelper';

export default function Product({
    id,
    product,
    size = "256",
    title,
    description,
    onSelect,
    isActive = false,
}) {
    // Custom layout for pattern products (series 9727)
    if (product.seriesID === 9727) {
        return (
            <li 
                className={`${styles.product} ${styles.patternProduct} ${isActive ? styles.active : ''}`} 
                data-id={id} 
                onClick={() => onSelect(id)}
            >
                <div className={styles.patternImgWrapper}>
                    <ProductThumbnail 
                        product={product}
                        size={parseInt(size, 10)}
                        alt={`${product.name} - ${product.description}`}
                    />
                </div>
                <div className={styles.productInfo}>
                    <div className={styles.title}>{product.name}</div>
                    <div className={styles.description}>{product.description}</div>
                    <div className={styles.description}>{product.sku}</div>
                </div>
            </li>
        );
    }

    // Default layout for other products
    return (
        <li 
            className={`${styles.product} ${isActive ? styles.active : ''}`} 
            data-id={id} 
            onClick={() => onSelect(id)}
        >
            <div className={styles.imgWrapper}>
                <ProductThumbnail 
                    product={product}
                    size={parseInt(size, 10)}
                    alt={`${title} - ${description}`}
                />
            </div>
            <div className={styles.productInfo}>
                <div className={styles.title}>{title}</div>
                <div className={styles.description}>{description}</div>
            </div>
        </li>
    );
}

Product.propTypes = {
    id: PropTypes.number.isRequired,
    product: PropTypes.object.isRequired,
    size: PropTypes.string,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    isActive: PropTypes.bool,
};
